// Simulador de grupo do WhatsApp (só aparece no ambiente de teste, com SIMULADOR_WHATSAPP=1 no suporte-app):
// grava uma mensagem "recebida" num grupo do Whaticket de teste — com ou sem @menção ao suporte — e mostra a conversa
// do grupo, inclusive o que o sistema respondeu (bot da menção, manual agendado). Nada sai pelo WhatsApp.
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Checkbox, FormControlLabel, Paper, TextField, Typography } from "@material-ui/core";

import suporteApi, { mensagemErro } from "./api";
import { dataBR } from "./comum";

const MARCA_BOT = "‎";

const SimuladorGrupo = ({ onMudou }) => {
  const [estado, setEstado] = useState(null);
  const [f, setF] = useState({ grupo: "TÉCNICOS SP - TESTE", autor_nome: "JOAO TECNICO", autor_numero: "11988887777",
    texto: "Bom dia, preciso de ajuda com a central da loja 555", mencionar: true });
  const [grupoId, setGrupoId] = useState(null);
  const [conversa, setConversa] = useState([]);
  useEffect(() => { suporteApi.get("/api/simulador").then((r) => setEstado(r.data)).catch(() => setEstado({ ativo: false })); }, []);
  const ler = useCallback(() => {
    if (grupoId) suporteApi.get(`/api/simulador/grupo/${grupoId}/conversa`).then((r) => setConversa(r.data)).catch(() => {});
  }, [grupoId]);
  useEffect(() => {
    if (!grupoId) return undefined;
    ler();
    const t = setInterval(() => { ler(); onMudou(); }, 5000);  // a leitura e o bot trabalham em segundo plano
    return () => clearInterval(t);
  }, [grupoId, ler, onMudou]);
  if (!estado?.ativo) return null;
  const enviar = async () => {
    try {
      const { data } = await suporteApi.post("/api/simulador/grupo", f);
      setGrupoId(data.contact_id);
      toast.info("Mensagem gravada no grupo. A leitura trata em alguns segundos.");
      setF({ ...f, texto: "" });
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  const c = (k, rotulo, extra = {}) => <TextField id={`sim-${k}`} size="small" margin="dense" label={rotulo} value={f[k]}
    onChange={(e) => setF({ ...f, [k]: e.target.value })} {...extra} />;
  return (
    <Paper variant="outlined" style={{ padding: 12, margin: "8px 0 16px", borderColor: "#ef6c00", background: "#fffaf3" }}>
      <Typography variant="subtitle2">Simulador de grupo (ambiente de teste — nada sai pelo WhatsApp)</Typography>
      <Typography variant="caption" color="textSecondary" component="div">
        {`Número do suporte nas menções: @${estado.identificador}. A mensagem entra no Whaticket de teste como se viesse do WhatsApp.`}
      </Typography>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {c("grupo", "Grupo", { style: { flex: "1 1 220px" } })}{c("autor_nome", "Quem escreve")}{c("autor_numero", "WhatsApp de quem escreve")}
      </div>
      {c("texto", "Mensagem", { fullWidth: true, multiline: true, minRows: 2 })}
      <FormControlLabel control={<Checkbox id="sim-mencionar" color="primary" checked={f.mencionar} onChange={(e) => setF({ ...f, mencionar: e.target.checked })} />}
        label="Mencionar o suporte (@número)" />
      <Button id="sim-enviar" size="small" color="primary" variant="contained" disabled={!f.texto.trim()} onClick={enviar}>Receber no grupo</Button>
      {grupoId && (
        <div style={{ marginTop: 10, maxHeight: 260, overflowY: "auto", background: "#efeae2", borderRadius: 8, padding: 8 }} id="sim-conversa">
          {conversa.map((m) => (
            <div key={m.id} style={{ display: "flex", justifyContent: m.fromMe ? "flex-end" : "flex-start", margin: "4px 0" }}>
              <div style={{ maxWidth: "75%", background: m.fromMe ? "#d9fdd3" : "#fff", borderRadius: 8, padding: "6px 9px", whiteSpace: "pre-wrap", fontSize: 13 }}>
                {!m.fromMe && <div style={{ fontSize: 11, fontWeight: 600, color: "#2e7d32" }}>{m.autor}</div>}
                {(m.body || "").replace(MARCA_BOT, "")}
                <div style={{ fontSize: 10, color: "#777", textAlign: "right" }}>{dataBR(m.createdAt)}{m.fromMe ? " · enviada pelo sistema" : ""}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Paper>
  );
};

export default SimuladorGrupo;
